import boxShadows from "./boxShadows";

const Shadows = [
    'none', // shadow для elevation 0
    boxShadows.xs, // shadow для elevation 1
    boxShadows.sm, // shadow для elevation 2
    boxShadows.md, // shadow для elevation 3
    boxShadows.lg, // shadow для elevation 4
    boxShadows.xl, // shadow для elevation 5
    boxShadows.xxl, // shadow для elevation 6
    boxShadows.xl, // shadow для elevation 7
    boxShadows.lg, // shadow для elevation 8
    boxShadows.md, // shadow для elevation 9
    boxShadows.sm, // shadow для elevation 10
    boxShadows.xs, // shadow для elevation 11
    boxShadows.xxl, // shadow для elevation 12
    boxShadows.xl, // shadow для elevation 13
    boxShadows.lg, // shadow для elevation 14
    boxShadows.md, // shadow для elevation 15
    boxShadows.sm, // shadow для elevation 16
    boxShadows.xs, // shadow для elevation 17
    boxShadows.xxl, // shadow для elevation 18
    boxShadows.xl, // shadow для elevation 19
    boxShadows.lg, // shadow для elevation 20
    boxShadows.md, // shadow для elevation 21
    boxShadows.sm, // shadow для elevation 22
    boxShadows.xs, // shadow для elevation 23
    boxShadows.xxl, // shadow для elevation 24
  ];
  export default Shadows;
